import Service, { inject as service } from '@ember/service';
import { formatUri, parseUri } from "../../utils/misc";
import { openPopupWindow } from "../../utils/window";

/**
 * @type {string}     Base URL for the linkedin sharing.
 */
const LINKED_IN_BASE_URL = 'https://www.linkedin.com/shareArticle';

/**
 * @type {string}     Base URL for the twitter intent.
 */
const TWITTER_BASE_URL = 'https://twitter.com/intent/tweet';

/**
 * Service for company related API calls.
 */
export default Service.extend({
  /**
   * Register Services
   */
  facebookProviderService: service('social/facebook-provider'),

  /**
   * share something through a mailto email link
   *
   * @param {String=}         opt_subject     The text for the title for linked in
   * @param {String=}         opt_body        The body for the email
   */
  shareEmail(opt_subject, opt_body) {
    let queryParams = {};
    if (opt_subject) {
      queryParams['subject'] = encodeURI(opt_subject);
    }

    if (opt_body) {
      queryParams['body'] = encodeURI(opt_body);
    }

    let queryStr = [];
    Object.keys(queryParams).forEach(key => {
      queryStr.push(`${key}=${queryParams[key]}`);
    });

    queryStr = queryStr.join('&');
    let mailTo = `mailto:?${queryStr}`;

    window.location.href = mailTo;
  },

  /**
   * Share a url through a user's facebook account.
   *
   * @param {String=} opt_url           Default is current url if not supplied
   * @param {String=} opt_description   The optional description to add in the share widget.
   */
  shareWithFacebook(opt_url = window.location.href, opt_description = null) {
    this.get('facebookProviderService').showShareDialog(opt_url, opt_description);
  },

  /**
   * Open and share an article on linked in.
   *
   * @param {String=}         opt_title           The text for the title for linked in
   * @param {String=}         opt_summary         The description text for linked in.
   * @param {String=}         opt_url             Url for the reference for the tweet.
   */
  shareLinkedIn(opt_title, opt_summary, opt_url) {
    let urlObject = parseUri(LINKED_IN_BASE_URL);

    urlObject.query = {
      'mini' : 'true',
      'source' : 'Glimmer'
    };

    if (opt_title) {
      urlObject.query['title'] = opt_title;
    }

    if (opt_summary) {
      urlObject.query['summary'] = opt_summary;
    }

    if (opt_url) {
      urlObject.query['url'] = opt_url;
    }

    urlObject.search = null;
    openPopupWindow(formatUri(urlObject), 'linkedInWindow', 650, 450);
  },

  /**
   * Open a tweet intent on twitter's website in a new window.
   *
   * @param {String=}         opt_prefilledText   The text for the tweet
   * @param {Array<String>=}  opt_hashTags        The array of hashtags
   * @param {String=}         opt_url             Url for the reference for the tweet.
   */
  shareTweet(opt_prefilledText = '', opt_hashTags = [], opt_url = '') {
    let urlObject = parseUri(TWITTER_BASE_URL);

    if (opt_prefilledText) {
      urlObject.query['text'] = opt_prefilledText;
    }

    if (opt_hashTags.length) {
      urlObject.query['hashtags'] = opt_hashTags.join(',');
    }

    if (opt_url) {
      urlObject.query['url'] = opt_url;
    }

    urlObject.search = null;
    openPopupWindow(formatUri(urlObject), 'tweetWindow', 550, 250);
  }
});
